<particle-analytics-content [isNavContentPaneEnabled]="true"
                            [reportType]="'GEMS'"
                            [solutionName]="'Computershare'"
                            [isResetButtonEnabled]="true"
                            [isEditButtonEnabled]="true"
>

</particle-analytics-content>
